import * as React from "react";

interface ILoaderProps {
    inline?: boolean;
}

const Loader: React.FC<ILoaderProps> = (props: ILoaderProps) => (
    <div
        className={`Loader ${
            props.inline !== undefined && props.inline ? "Loader--inline" : ""
        } `}
    >
        <div className="Loader__circle"></div>
    </div>
);

export default Loader;
